import {TranslocoService} from "@ngneat/transloco";
import {PropertiesErrorsInterface} from '../../../shared/csv-validation/properties-errors.interface';

export class DevicePropertiesErrors implements PropertiesErrorsInterface{

  private devicePropertiesErrors: { [key: string]: string };

  constructor(private readonly  i18n: TranslocoService) {
    this.i18n.selectTranslation().subscribe(() => {
      this.devicePropertiesErrors = {
        serialNumber: this.i18n.translate('info.importDevicesCsv.fields.serialNumber'),
        deviceAlias: this.i18n.translate('info.importDevicesCsv.fields.deviceAlias'),
        deviceDescription: this.i18n.translate('info.importDevicesCsv.fields.deviceDescription'),
        deviceCategory: this.i18n.translate('info.importDevicesCsv.fields.deviceCategory'),
        deviceTimeZone: this.i18n.translate('info.importDevicesCsv.fields.deviceTimeZone'),
        deviceTechnicalDetails: this.i18n.translate('info.importDevicesCsv.fields.deviceTechnicalDetails'),
        deviceTemplate: this.i18n.translate('info.importDevicesCsv.fields.deviceTemplate'),
        assetAlias: this.i18n.translate('info.importDevicesCsv.fields.assetAlias'),
        assetDescription: this.i18n.translate('info.importDevicesCsv.fields.latitude'),
        latitude: this.i18n.translate('info.importDevicesCsv.fields.latitude'),
        longitude: this.i18n.translate('info.importDevicesCsv.fields.longitude'),
        assetTimeZone: this.i18n.translate('info.importDevicesCsv.fields.assetTimeZone'),
        representation: this.i18n.translate('info.importDevicesCsv.fields.representation'),
        assetTechnicalDetails: this.i18n.translate('info.importDevicesCsv.fields.assetTechnicalDetails'),
        assetTemplate: this.i18n.translate('info.importDevicesCsv.fields.assetTemplate')
      }
    })
  }

  public getTranslation(property): string | null {
    return this.devicePropertiesErrors.hasOwnProperty(property) ? this.devicePropertiesErrors[property] : null;
  }
}

